import { css } from 'styled-components';
import { OtpViewProps } from './models';
import { viewWrapper } from '../../styles';

const stickyWrapperHeight = 80;
const submitButtonWidth = css`
  width: 252px;
`;

export const OtpView = css<OtpViewProps>(({ theme }) => {
  return css`
    ${viewWrapper};

    > .phone-number-input-section {
      width: 100%;
      font-size: 14px;
      margin-top: 20px;
      text-align: left;

      @media only screen and ${theme.device.mobileXL} {
        font-size: 18px;
        width: 480px;
      }

      > .phone-number-container {
        margin-top: 5px;
      }
    }

    > .title {
      font-size: 18px;
      line-height: 27px;
      font-weight: 600;
      white-space: pre-line;
      margin-bottom: 12px;

      @media only screen and ${theme.device.mobileXL} {
        font-size: 25px;
        line-height: 30px;
        max-width: 550px;
      }
    }

    > .sub-title {
      color: ${theme.colors.primaryDeepBlue};
      font-weight: 500;
      font-size: 18px;
      white-space: pre-wrap;
      line-height: 27px;
      margin-top: 30px;
    }

    > .pin-code-methods-container {
      margin-top: 22px;
    }

    > .legals-container {
      margin-top: 32px;
      text-align: left;
      display: flex;
      flex-direction: column;
      max-width: 335px;
      gap: 15px;
      max-height: 140px;
      height: 140px;

      > p {
        font-size: 10px;
        color: ${theme.colors.darkGray};
        line-height: 15px;
        white-space: pre-wrap;
      }
    }

    > .healthcare-paragraph {
      font-size: 10px;
      color: ${theme.colors.darkGray};
      line-height: 15px;
      text-align: left;
      max-width: 1040px;

      @media only screen and ${theme.device.mobileXL} {
        text-align: center;
        width: 90%;
      }
    }

    > .button-wrapper {
      display: flex;
      flex: 1 0 0;

      > .submit-button {
        ${submitButtonWidth};
        height: 50px;
        margin: 40px 0 10px;
      }
    }

    > .legal-content {
      margin-top: 30px;
      max-width: 1040px;

      @media only screen and ${theme.device.mobileXL} {
        width: 90%;
      }
    }

    > .mobile-button-container {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;

      > .scroll-notice {
        background: ${theme.colors.primaryDeepBlue};
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
        padding: 8px 16px;
      }

      .submit-button {
        width: 255px;
        height: 40px;
        margin: 0;
      }

      > .sticky-button-wrapper {
        padding: 10px;
        background-color: white;
        height: ${stickyWrapperHeight}px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px -6px 8px -4px rgba(24, 39, 75, 0.04);

        > .submit-button-container {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;

          > .overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: transparent;
          }
        }
      }
    }

    > .sticky-button-wrapper-placeholder {
      padding-top: ${stickyWrapperHeight}px;
    }
  `;
});
